module.exports = __webpack_public_path__ + "img/page.7a999c8d.png";